<template>
    <form @submit.prevent="handleOtpSubmit" class="form-signin">
    <h1 class="h3 mb-3 fw-normal">Verify OTP Code</h1>

    <div class="form-floating">
      <input type="text" class="form-control" v-model="otp" placeholder="Enter received OTP" required>
    </div>
    <button class="btn btn-primary w-100 py-2" type="submit">Verify</button>
  </form>
</template>

<script>
import axios from 'axios';
  export default {
    name: "LoginView",
    data() {
      return {
        otp: '',
      }
    },
    methods: {
      async handleOtpSubmit() {
         const response = await axios.post('verify-email/', {
            otp: this.otp,
         });

         console.log(response);
         this.$router.push('/login');

      }
    }
  }
</script>

<style>

</style>